var map = {
	"./arrow-lift.svg": "a5e1",
	"./arrow-right.svg": "6929",
	"./arrow-up.svg": "cd54",
	"./ashbin.svg": "5fa7",
	"./input_restart.svg": "cca3",
	"./login_password.svg": "1c21",
	"./login_sms.svg": "ae95",
	"./logo.svg": "bb69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";